import React, { useMemo, useRef } from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import {
  Column,
  Sorting,
  HeaderFilter,
  StateStoring,
} from 'devextreme-react/data-grid';
import DataGrid from 'components/devExtreme/DataGrid';
import { dataGridExtension } from 'components/devExtreme';
import columnSchema from 'components/underwrite/acquisition/channelWorkflow/AutoPricingResultsSchema';

const AutoPricingResultsGrid = ({ classes, results }) => {
  const grid = useRef(null);

  const onSetGridRef = g => {
    grid.current = g;
  }

  let dataSource = useMemo(() => {
    if (results) {
      return results;
    }
    return null;
  }, [results]);

  const getCellRender = (cell) => {
    if (!results || cell.value === null || cell.value === undefined) {
      return null
    }

    switch (cell.column.dataField) {
      case 'isSuccess':
        return cell.value ? 'True' : 'False'
      default:
        return null;
    }
  }

  let columns = useMemo(() => {
    return columnSchema.map(({ field, displayName, width, type, format, visible, sortIndex, sortOrder, headerFilter }) => {
      let cellRender = null;
      if (['isSuccess'].includes(field)) {
        cellRender = getCellRender;
      }
      return (
        <Column
          key={field}
          dataField={field}
          caption={displayName}
          width={width}
          dataType={type}
          format={format}
          allowSorting={true}
          allowGrouping={true}
          visible={visible !== false}
          sortIndex={sortIndex}
          sortOrder={sortOrder}
          cellRender={cellRender}
        // showInColumnChooser={shouldShow}
        >
          <HeaderFilter dataSource={(options) => dataGridExtension.headerFilterSort(options, dataSource, field, type, headerFilter)} />
          {/* <ColumnHeaderFilter dataSource={dataGridExtension.headerFilterSort(dataSource, field, type, headerFilter)} /> */}
        </Column>
      )
    })
  }, [dataSource]);
  return (
    <DataGrid
      ref={onSetGridRef}
      dataSource={dataSource}
      // keyExpr='id'
      allowColumnReordering={true}
      allowColumnResizing={true}
      columnResizingMode='widget'
      showBorders={true}
      showRowLines={true}
      showColumnLines={true}
      height={435}
      width={'100%'}
      hoverStateEnabled={true}
      columnAutoWidth={true}
      className={classes.grid}
    >
      <HeaderFilter visible={true} allowSearch={true} hideSelectAllOnSearch={false} />
      <Sorting mode={'multiple'} />
      <StateStoring
        enabled={false}
        type={'custom'}
        storageKey={'storage'}
        customSave={state => console.log(state)}
      />
      {columns}
    </DataGrid>
  )
}

const styles = theme => ({
  grid: {
    paddingBottom: 8
  },
  textFieldRoot: {
    height: 70,
    marginBottom: 16,
    paddingRight: 8,
    flexBasis: '25%'
  },
  errorText: {
    lineHeight: 1
  },
  textWrapper: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  textLabel: {
    minWidth: '200px'
  },
  divider: {
    marginTop: '4px',
    marginBottom: '4px'
  }
});

export default compose(
  withStyles(styles)
)(AutoPricingResultsGrid);